import { render, staticRenderFns } from "./hospitalAllocation.vue?vue&type=template&id=1866aae8&scoped=true&"
import script from "./hospitalAllocation.vue?vue&type=script&lang=js&"
export * from "./hospitalAllocation.vue?vue&type=script&lang=js&"
import style0 from "./hospitalAllocation.vue?vue&type=style&index=0&id=1866aae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1866aae8",
  null
  
)

export default component.exports